import React from "react";
import "./TimeRegistrationShiftTag.scss";

/**
 * Chip compacto de turno en la tabla de fichajes (nombre + horario).
 * Props: nombre, horario, color de fondo, borde (y color de texto opcional).
 */
const TimeRegistrationShiftTag = ({
	name,
	schedule,
	backgroundColor,
	borderColor,
	textColor,
	title,
	className = "",
}) => {
	const border =
		borderColor != null && borderColor !== ""
			? borderColor
			: backgroundColor;

	return (
		<div
			className={`time-registration-shift-tag ${className}`.trim()}
			style={{
				backgroundColor: backgroundColor || undefined,
				borderColor: border || undefined,
				color: textColor || undefined,
			}}
			title={title}
		>
			<span className="time-registration-shift-tag__name">{name}</span>
			{schedule ? (
				<span className="time-registration-shift-tag__schedule">
					{schedule}
				</span>
			) : null}
		</div>
	);
};

export default TimeRegistrationShiftTag;
